import createAPIRequestId from '../helpers/createAPIRequestId'
import store from '../store/index'
//---------------------------
// edit character adjustment
//---------------------------
export default async function useEditCharacterAdj(this_adj) {
  console.log('-------------------------------------')
  console.log('IN useEditCharacterAdj....')

  console.log('>>>> this_adj:', this_adj)

  return new Promise((resolve) => {
    //--------------
    // access store
    //--------------
    const this_store = store
    //--------------------
    // set api call parms
    //--------------------
    let parm_id = ''
    let parm_partialInd = false

    if (this_adj.id != '') {
      parm_id = this_adj.id
      parm_partialInd = this_adj.action !== 'DELETE' ? true : false
    }
    //---------------------------------------------
    // declare request parms to create api request
    //--------------------------------------------
    let request_parms = {
      endpoint: 'api/v1/character-' + this_adj.category + '-adjs/',
      partialInd: parm_partialInd,
      id: parm_id,
    }
    //---------------------------------------------------
    // where DELETE add indicator for create api request
    //---------------------------------------------------
    if (this_adj.action === 'DELETE') {
      request_parms.deleteInd = true
    }
    //--------------------------
    // create api request by id
    //--------------------------
    let request = createAPIRequestId(request_parms)
    //---------------
    // set api parms
    //---------------
    let api_parms = {
      api_request: request,
    }
    //----------------------------------
    // include payload where not DELETE
    //----------------------------------
    if (this_adj.action !== 'DELETE') {
      api_parms.payload = this_adj.payload
    }
    console.log('api_parms = ', api_parms)
    //----------
    // call api
    //----------
    this_store.dispatch('characters/editCharacterAdj', api_parms).then((response) => {
      resolve(response)
    })
  })
}
